module.exports = __webpack_public_path__ + "img/error-loading.ef8bbd45.gif";